"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _search = _interopRequireDefault(require("@/components/college/search.vue"));
var _courseItem = _interopRequireDefault(require("@/components/college/courseItem.vue"));
var _index = require("@/api/college/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    Search: _search.default
  },
  props: {},
  data: function data() {
    return {
      query: {
        pageNum: 1,
        pageSize: 18,
        courseName: '',
        majorName: ''
      },
      total: 0,
      onlineCourse: []
    };
  },
  created: function created() {
    this.getOnlineCourse();
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getOnlineCourse();
    },
    //在线精品课
    getOnlineCourse: function getOnlineCourse() {
      var _this = this;
      (0, _index.peCourseList)({
        courseType: "1",
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          _this.onlineCourse = res.data.list;
          _this.total = res.data.total;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getOnlineCourse();
    }
  }
};